// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#settings[data-v-12241665] {\n  background-color: white;\n  width: 100%;\n  height: 100%;\n  z-index: 1001;\n  box-sizing: border-box;\n}\n#settings .version[data-v-12241665] {\n  font-size: 10px;\n  padding-top: 10px;\n  padding-left: 16px;\n  text-align: center;\n  background: white;\n}", ""]);
// Exports
module.exports = exports;
